import { render, staticRenderFns } from "./CSCFormAnAnswerDlg.vue?vue&type=template&id=4af6d320&"
import script from "./CSCFormAnAnswerDlg.vue?vue&type=script&lang=js&"
export * from "./CSCFormAnAnswerDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports